import SetPasswordLinkExpiredContainer from "./SetPasswordLinkExpiredContainer";

export default SetPasswordLinkExpiredContainer;
